//@flow
import {call, select} from 'redux-saga/effects'
import callRefreshTokens from '$api/refreshTokens'
import {setTokensState} from '$util'

import {selectRefreshToken, selectEmail} from '$src/auth/selectors'

import {callWithFlags} from '$util'

export default function* refreshTokens(): Generator<> {
  const refresh_token: ?string = yield select(selectRefreshToken)
  const email: ?string = yield select(selectEmail)

  const {id_token, uid}: {id_token: string, uid: string} =
    yield callWithFlags('refreshTokens', callRefreshTokens, {refresh_token, email})

  yield call(setTokensState, {uid, id_token, refresh_token, email})

}



// WEBPACK FOOTER //
// ./src/auth/sagas/refreshTokens.js